import { t } from '@/locales'
export function validateEmail(rule: any, value: string) {
  const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
  // if (!value)
  //   return new Error(t('auth.validation.required_email'))

  if (value && !emailRegex.test(value))
    return new Error(t('auth.validation.invalid_email'))

  return true
}

export function validateCode(rule: any, value: string) {
  if (/\s/.test(value))
    return new Error(t('globalList.validator.codeInvalid'))

  return true
}

export function noSideSpace(value: string) {
  return !/ /g.test(value)
}

export async function validatePassword(rule: any, value: string) {
  // Regex kiểm tra:
  // - Ít nhất 1 chữ in hoa
  // - Ít nhất 1 chữ số
  // - Độ dài từ 8 đến 30 ký tự
  const uppercaseReg = new RegExp('[A-Z]', 'g')
  const numberReg = new RegExp('\\d', 'g')
  const specialReg = new RegExp('[!@#$%^&*(),.?":{}|<>]', 'g')

  const checkMinLength = value && value.length < 8
  const checkMaxLength = value && value.length > 30
  const checkUppercaseReg = value && !uppercaseReg.test(value)
  const checkNumberReg = value && !numberReg.test(value)
  const checkSpecialReg = value && !specialReg.test(value)

  if (checkMinLength)
    return Promise.reject(new Error(t('auth.validation.min_length_password')))

  if (checkMaxLength)
    return Promise.reject(new Error(t('auth.validation.max_length_password')))

  if (checkUppercaseReg)
    return Promise.reject(new Error(t('auth.validation.uppercase_password')))

  if (checkNumberReg)
    return Promise.reject(new Error(t('auth.validation.number_password')))

  if (checkSpecialReg)
    return Promise.reject(new Error(t('auth.validation.special_password')))

  return Promise.resolve()
}

export function validateNoSpecialOrNumber(rule: any, value: string) {
  // Regex cho phép: chỉ chữ cái và khoảng trắng (bao gồm cả chữ có dấu tiếng Việt)
  const regex = /^[A-Za-zÀ-ỹ\s]+$/u
  const checkRegex = value && !regex.test(value)

  if (checkRegex)
    return new Error(t('auth.validation.no_special_or_number'))
  // "Thông tin không được phép chứa các ký tự đặc biệt hoặc số."

  return true
}
